import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Input, Table, Button } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { listEventRegistrations } from '../../utils/eventRegistration';
import { ToastContainer, toast } from 'react-toastify';

const RegistrationsList = () => {
  const { eventId } = useParams();
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try {
      setLoading(true);
      const res = await listEventRegistrations(eventId);
      if (res?.status === 200) {
        setRows(res.data?.data || []);
      } else {
        const msg = res?.response?.data?.message || res?.message || 'Failed to load registrations';
        toast(msg, { position: 'top-center', hideProgressBar: true, className: 'bg-danger text-white' });
      }
    } catch (e) {
      toast('Failed to load registrations', { position: 'top-center', hideProgressBar: true, className: 'bg-danger text-white' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, [eventId]);

  const filtered = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return rows;
    return rows.filter(r =>
      (r.full_name || '').toLowerCase().includes(term) ||
      (r.email || '').toLowerCase().includes(term)
    );
  }, [rows, search]);

  const exportCsv = () => {
    const headers = ['Full Name','Email','Phone','Guests','Total','Status','Registered At','Updated At'];
    const lines = filtered.map(r => [
      r.full_name || '', r.email || '', r.phone_number || '', r.guests_count ?? '', r.attendees_count ?? '', r.status || '', r.created_at || '', r.updated_at || ''
    ].map(v => `"${String(v).replace(/"/g,'""')}"`).join(','));
    const csv = [headers.join(','), ...lines].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `event_${eventId}_registrations.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Event Registrations" pageTitle="Events" />
        <ToastContainer />
        <Row className="mb-3">
          <Col md={4}><Input placeholder="Search name or email" value={search} onChange={e => setSearch(e.target.value)} /></Col>
          <Col className="text-end"><Button onClick={exportCsv} disabled={loading}>Export CSV</Button></Col>
        </Row>
        <Card>
          <CardBody>
            <Table responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Guests</th>
                  <th>Total</th>
                  <th>Status</th>
                  <th>Registered At</th>
                  <th>Updated At</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((r, idx) => (
                  <tr key={idx}>
                    <td>{r.full_name}</td>
                    <td>{r.email}</td>
                    <td>{r.phone_number}</td>
                    <td>{r.guests_count}</td>
                    <td>{r.attendees_count}</td>
                    <td>{r.status}</td>
                    <td>{r.created_at}</td>
                    <td>{r.updated_at}</td>
                  </tr>
                ))}
                {!loading && filtered.length === 0 && (
                  <tr><td colSpan={8} className="text-center">No registrations</td></tr>
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default RegistrationsList;

